import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_nouvelle_generation_ia(langs) {
  let translations;
  try {
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error("Erreur lors du chargement des traductions pour la langue", langs, error);
    return;
  }

  const tour = guide_tour_init();
  const t = translations.ia.nouvelleGen;

  // Étape 1 — Quota journalier + crédits bonus
  guide_tour_step_start(tour, translations, t.quota.titre, t.quota.texte, "#ia-quota", "bottom");

  // Étape 2 — Fichier spool
  guide_tour_step(tour, translations, t.spool.titre, t.spool.texte, "#ia-spool", "right");

  // Étape 3 — PDF cible
  guide_tour_step(tour, translations, t.targetPdf.titre, t.targetPdf.texte, "#ia-target-pdf", "right");

  // Étape 4 — Fond de page
  guide_tour_step(tour, translations, t.fondPage.titre, t.fondPage.texte, "#ia-fond-page", "right");

  // Étape 5 — Nom du format
  guide_tour_step(tour, translations, t.formatName.titre, t.formatName.texte, "#ia-format-name", "right");

  // Étape 6 — Type de document
  guide_tour_step(tour, translations, t.docType.titre, t.docType.texte, "#ia-doc-type", "right");

  // Étape 7 — Bouton Générer
  guide_tour_step(tour, translations, t.generer.titre, t.generer.texte, "#ia-btn-generer", "right");

  // Étape 8 — Onglets (dont Fichiers générés)
  guide_tour_step_complete(tour, translations, t.fichiersGeneres.titre, t.fichiersGeneres.texte, "#ia-tabs", "bottom");

  tour.start();
}
